// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__kN0Gf","navbarNav":"Navigation_navbarNav__ilPX+"};